import * as Common from '@tfo/common'
import * as React from 'react'
import { observer } from 'mobx-react'
import ReportsItemDate from './ReportsItemDate'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import '../ReportsItem.scss'
import { Elements } from '@tfo/common'
const { Label } = Elements

export interface ReportsItemProps {
	data: Common.models.IOrderClient
	onClick: any
	reportPackages: Common.models.ReportPackage[]
	showCompanyName: boolean
}

const ReportsItemArchived = ({
	data,
	intl,
	onClick,
	reportPackages,
	showCompanyName,
}: ReportsItemProps & WrappedComponentProps) => (
	<div
		className={'ReportsItem ReportsItem--archived ReportsItem--active'}
		id={'reportsItem_' + data.id.toString()}
		data-cy="archived-order">
		<div className={'ReportsItem__Inner'} onClick={onClick}>
			{showCompanyName && (
				<div className={'ReportsItem__Cell'}>{data.companyName}</div>
			)}

			<div className={'ReportsItem__Cell'}>
				{reportPackages.find(x => x.id === data.servicePackageId)
					?.customName ?? ''}
			</div>
			<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
				{data.controlPerson}
			</div>
			<ReportsItemDate
				date={data.created}
				label={intl.formatMessage({ id: 'common.ordered' })}
			/>
			<ReportsItemDate
				date={data.delivered}
				label={intl.formatMessage({ id: 'common.delivered' })}
				emptyDateLabel={intl.formatMessage({ id: 'common.notDelivered' })}
			/>
		</div>
	</div>
)
export default injectIntl(observer(ReportsItemArchived))
